import { InputComponentRequirementDialogState } from ".";
import { INIT_ERROR_RESULT_DATA } from "../../../util";

const fieldPath = {
  tstUseTypeCd: "tstUseTypeCd",
  reqType: "reqType",
};

const reqType = [
  { label: "No", value: "OnlyIf" },
  { label: "Yes", value: "Both" },
];

export const displayColumn = [
  { label: "DIP by Region", value: "dipByRgn" },
  { label: "Component ID", value: "cpntId" },
  { label: "Description", value: "cpntReqDesc" },
];

export type DisplayColumnKeys =
  | "delFlg"
  | "dipByRgn"
  | "cpntId"
  | "cpntReqDesc";

export const InputComponentRequirementDialogInitialState: InputComponentRequirementDialogState =
  {
    isShow: false,
    saved: {},
    edited: {},
    codes: {
      tstUseFlg: [],
      dipByRegionList: [],
      reqType: reqType,
    },
    fieldPath: fieldPath,
    displayColumn: displayColumn,
    pjtId: "",
    updateDateTime: "",
    status: {
      invalidList: [],
      invalidRecordList: [],
      isSaved: false,
    },
    spreadsheet: {
      tmplateRow: {
        ...INIT_ERROR_RESULT_DATA,
        isAddRow: false,
        delFlg: false,
        cpntReqId: "",
        dipByRgn: "",
        cpntId: "",
        cpntReqDesc: "",
      },
    },
  };
